import gql from 'graphql-tag';

export const querySuggestedAccountName = gql`
  query suggestedAccountName(
    $industry: AccountIndustry!
  ) {
    suggestedAccountName(industry: $industry)
  }
`;

export default querySuggestedAccountName;
